import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { FontsUrl } from '../constants/fonts.urls';
import { TDocumentDefinitions } from 'pdfmake/interfaces';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor() {
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
    (pdfMake as any).fonts = {
      FrutigerNext: {
        bold: FontsUrl.frutiger.bold,
        normal: FontsUrl.frutiger.normal,
        italics: FontsUrl.frutiger.medium,
        bolditalics: FontsUrl.frutiger.bold,
      }
    };
  }

  createPdfAndOpen(docDefinition: TDocumentDefinitions): void {
    pdfMake.createPdf(docDefinition).open();
  }
}
